<div class="dialog-container">
  <oph-x-button class="cb-alert-dialog__close-button" (click)="onCancel()" title="Close dialog" />
  <cb-dialog-header
    icon="assets/img/icons/challenge-builder/alerts.png"
    [title]="titleVariable() + ' Alert'"
    [description]="titleVariable() + ' custom push notification.'"
  />

  <div class="dialog-content">
    <div class="form-group">
      <label class="form-label">Select days</label>
      <div class="days-selector">
        @for (day of dayOptions; track day.value) {
          <button
            type="button"
            class="day-chip"
            [class.selected]="isDaySelected(day.value)"
            (click)="toggleDay(day.value)"
          >
            {{ day.label }}
          </button>
        }
      </div>
    </div>

    <div class="form-group">
      <label class="form-label">Time of day</label>
      <button type="button" class="time-select" (click)="onTimeClick()">
        <mat-icon svgIcon="clock" class="clock-icon"></mat-icon>
        <span class="time-text">{{ formattedTime() }}</span>
      </button>
    </div>

    <div class="form-group">
      <div class="form-label-row">
        <label class="form-label">Message</label>
        <span class="char-count">{{ messageLength() }}/{{ maxMessageLength }}</span>
      </div>
      <textarea
        class="form-textarea"
        placeholder="Message"
        maxlength="140"
        [value]="alertText()"
        (input)="onAlertTextChange($event)"
      ></textarea>
    </div>
  </div>

  <cb-dialog-footer [loading]="loading()" [saveDisabled]="saveDisabled()" (cancel)="onCancel()" (save)="onSave()" />

  <!-- Time selector overlay -->
  <div class="time-selector-overlay" [class.visible]="showTimeSelector()">
    <div class="time-selector-modal">
      <div class="modal-header">
        <oph-x-button (click)="closeTimeSelector()"></oph-x-button>
      </div>
      <oph-time-selector
        [hoursControl]="$any(startTimeForm.get('hours'))"
        [minutesControl]="$any(startTimeForm.get('minutes'))"
        [ampmControl]="$any(startTimeForm.get('ampm'))"
      ></oph-time-selector>
    </div>
  </div>
</div>
